import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';

export interface SearchCSSStyle extends CRBTUICSSStyle
{

}

export class  SearchCSSStyleImpl extends CRBTUICSSStyleImpl implements SearchCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width:"100%",
            height:'100%',
            display:'flex',
            justifyContents: "center",
            flexDirection: "row",
            flexFlow: "row wrap"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/search/searchcss.tsx